import Button from 'components/Button';
import Img from 'components/Img';
import ThemedBlockContainer from 'components/ThemedBlockContainer';
import type { SimpleLink } from 'models/sitecore';
import type { ColorString } from 'types';

interface Props {
	centerImageAlt: string | undefined;
	centerImageSrc?: string;
	className?: string;
	color: ColorString;
	link: SimpleLink;
	topLeftImageSrc?: string;
}

/** Corner theme image, center image and link */
export default function MicroContentTheme({
	centerImageAlt,
	centerImageSrc,
	className,
	color,
	link,
	topLeftImageSrc,
}: Props) {
	return (
		<ThemedBlockContainer
			color={color}
			topLeftImageSrc={topLeftImageSrc}
			className={className}
			contentClassName="flex flex-col items-center py-6"
		>
			{centerImageSrc && (
				<>
					<Img
						src={centerImageSrc}
						alt={centerImageAlt}
						width={360}
						height={180}
						jpgOptimized={false}
						className="mx-auto mb-6 md:hidden"
					/>
					<Img
						src={centerImageSrc}
						alt={centerImageAlt}
						width={810}
						height={405}
						jpgOptimized={false}
						className="mb-6 max-md:hidden"
					/>
				</>
			)}
			{link && (
				<Button
					key={link.href}
					href={link.href}
					variant="secondary"
					className="mx-4"
				>
					{link.text}
				</Button>
			)}
		</ThemedBlockContainer>
	);
}
MicroContentTheme.displayName = 'MicroContentTheme';
